export enum ReactFlowNodeStatus {
	SUCCESS = 'success',
	WARNING = 'warning',
	ERROR = 'error',
	ACTIVE = 'active',
	CREATING = 'creating',
	CREATION_SUCCESS = 'creationSuccess',
	CREATION_ERROR = 'creationError',
	SAVED = 'saved',
	DISABLED = 'disabled',
	WORKFLOW_REVIEW = 'workflowReview',
}

export enum ReactFlowNodeType {
	TUTORIAL = 'tutorial',
	UNI_DIRECTIONAL = 'uniDirectional',
	BI_DIRECTIONAL = 'biDirectional',
}

export enum ReactFlowNodeShape {
	ROUND = 'round',
	SQUARE = 'square',
}

export enum ReactFlowHelpNodeIDList {
	START = 'START',
	END = 'END',
}

export function isTerminalTaskId(taskId: string): boolean {
	return taskId === ReactFlowHelpNodeIDList.START || taskId === ReactFlowHelpNodeIDList.END;
}

export enum ReactFlowNodeSize {
	SMALL = 'small',
	DEFAULT = 'default',
}
